import React from "react";

export interface ProjectFilterNumberProps {
    filteredProjectNumber: number;
    setFilteredProjectNumber: (number: number) => void;
}

export const ProjectFilterNumberContext = React.createContext<ProjectFilterNumberProps | undefined>(undefined);